<template>
  <Stack align="center" gap="xs" class="w-full px-xs md:w-auto md:px-none">
    <Input
      id="search-invoices"
      class="md:!w-[445px]"
      :model-value="search"
      label="Search Invoices"
      :label-visible="false"
      placeholder="Search invoice no. or job reference"
      :is-search="true"
      @update:input-value="(value) => updateSearchValue(value as string)"
      @keydown.enter="handleSearch"
      data-fs="invoicesSearchInput"
      data-test-id="invoicesSearchBar"
    />
    <Button
      size="md"
      variant="secondary"
      @click="toggleFilterInvoicesTray"
      data-fs="filterInvoicesButton"
      data-test-id="filterBtn"
      >Filter</Button
    >
  </Stack>

  <LazyFilterInvoicesTray :search-value="search" @update:search="(value) => updateSearchValue(value)" />
</template>

<script lang="ts" setup>
const { filterDocuments, resetFilters } = useDocuments();
const { toggleFilterInvoicesTray } = useUIState();

const search = ref<string>("");

const updateSearchValue = (value: string) => {
  search.value = value;

  if (search.value.length === 0) resetFilters();
};

const handleSearch = () => {
  if (search.value.length === 0) return;

  filterDocuments({
    numberOrJobReference: search.value,
  });
};
</script>
